
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { TBlog } from "apiTypes";
import MolhamButton from "components/ReuseableCompos/MolhamButton";
import { createSupportIssue } from "components/supportDataManager";
import { useModeContext } from "context/ModeContext";
import useMobile from "customHooks/useMobile";
import { nextCheckoutItemSourceManager } from "customHooks/useNextCheckoutItemSource";
import dayjs from "dayjs";
import { m } from "framer-motion";
import { GetServerSideProps } from "next";
import useTranslation from "next-translate/useTranslation";
import Image from "next/image";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import { FiHeart } from "react-icons/fi";
import { toast } from "react-toastify";
import styled from "styled-components";
import removeUndefined from "utils/removeUndefined";
import FeedbackModal from "../../components/Donate/FeedbackModal";
import CommentContainer from "../../components/Posts/CommentContainer";
import BlogShareBtn from "../../components/ReuseableCompos/BlogShareBtn";
import ButtonfulModal, { ButtonfulModalButton, } from "../../components/ReuseableCompos/ButtonfulModal";
import StyledDate from "../../components/ReuseableCompos/StyledDate";
import SEO from "../../components/Seo";
import { API_URL, NEXT_URL_PROXY, blogsURL, tragetableFallbackImg, } from "../../config";
import { useAuthContext } from "../../context/AuthContext";
import { AuthModalContext } from "../../context/AuthModalContext";
import useHeaderTitleSetter from "../../customHooks/useHeaderTitleSetter";
import useLike from "../../customHooks/useLike";
import useModal from "../../customHooks/useModal";
import { getData } from "../../utils/getData";
type Props = {
    blog: TBlog;
};
const Post = ({ blog }: Props) => {
    const { showModal: showAddEditCommentModal, handleCloseModal: handleCloseAddEditCommentModal, handleShowModal: handleShowAddEditCommentModal, } = useModal();
    const { showModal, handleCloseModal, handleShowModal } = useModal();
    const { showModal: showFBModal, handleCloseModal: handleCloseFBModal, handleShowModal: handleShowFBModal, } = useModal();
    const [data, setData] = useState<TBlog>(blog || undefined);
    const { locale, query, push } = useRouter();
    const blogId = query.id;
    useEffect(() => {
        getData(`${NEXT_URL_PROXY}/${blogsURL}/${blogId}`, null, {
            locale
        }).then((res) => {
            setData(res.data);
        });
    }, [locale, blogId]);
    const { donor } = useAuthContext();
    const { contents, counters, preview_image, id, published_at } = data;
    const [reactingCounts, setReactingCounts] = useState({
        comments_count: counters?.comments
    });
    const singleBlogURL = `${NEXT_URL_PROXY}/${blogsURL}/${id}`;
    useHeaderTitleSetter({ title: addEllipsis(contents?.title, 20) });
    const { like, onLikeBtnClick, likeBtnClicked } = useLike(counters?.likes, `${singleBlogURL}/likes`, data?.liked_by_auth);
    useEffect(() => {
        nextCheckoutItemSourceManager.setNextCheckoutItemSource(nextCheckoutItemSourceManager.options.blog_post);
    }, []);
    const { t } = useTranslation("common");
    const buttons: ButtonfulModalButton = [
        [
            {
                text: t("single_targetable-send_feedback"),
                btnFntSz: "fs-lg",
                onClick: () => {
                    handleCloseModal();
                    handleShowFBModal();
                },
                color: "primary"
            },
            {
                text: t(`single_targetable-chat`),
                onClick: () => {
                    handleCloseModal();
                },
                color: "primary",
                href: "#chat-with-support"
            },
        ],
        [
            {
                text: t(`cancel`),
                onClick: () => handleCloseModal(),
                color: "primary",
                fontWeight: "bold"
            },
        ],
    ];
    const buttonsNoAuth: ButtonfulModalButton = [
        [
            {
                text: t(`single_targetable-chat`),
                onClick: () => {
                    handleCloseModal();
                },
                color: "primary",
                href: "#chat-with-support"
            },
        ],
        [
            {
                text: t(`cancel`),
                onClick: () => handleCloseModal(),
                color: "primary",
                fontWeight: "bold"
            },
        ],
    ];
    const { handleShowAuthModal } = useContext(AuthModalContext);
    const onCommentBtnClick = () => {
        !donor ? handleShowAuthModal() : handleShowAddEditCommentModal();
    };
    const isMobile = useMobile("md");
    const matches = useMobile("lg");
    const { theme } = useModeContext();
    const [isDark, setIsDark] = useState(false);
    useEffect(() => {
        setIsDark(theme === "dark");
    }, [theme]);
    const [isLoading, setIsLoading] = useState(false);
    const onCreate = async (d) => {
        setIsLoading(true);
        const res = await createSupportIssue({
            content: d.content,
            subject: d.subject
        });
        if (res.status === 200) {
            handleCloseFBModal();
            toast.success(t("issue_created"));
            push("/profile/support-issues");
        }
        else {
            toast.error(t("something_went_wrong"));
        }
        setIsLoading(false);
    };
    return (<>
      <SEO title={contents?.title} additinalProps={{
            openGraph: {
                article: {
                    authors: ["molham team"],
                    publishedTime: published_at,
                    section: "NGO",
                    tags: ["NGO", "Donation", "Charity"]
                }
            }
        }} molhamImages={preview_image}/>

      <ButtonfulModal handleCloseModal={handleCloseModal} showModal={showModal} buttons={donor ? buttons : buttonsNoAuth}/>
      <FeedbackModal closeModalOffCanvas={handleCloseFBModal} showModalOffcanvas={showFBModal} onSubmit={onCreate} isLoading={isLoading} isAdd/>

      <div className="justify-content-center container p-0">
        <div className="d-flex justify-content-center align-items-center w-100">
          <div>
            <Image unoptimized src={preview_image?.thumbnails?.[isMobile ? "1:1" : "16:9"] ||
            tragetableFallbackImg} alt={contents?.title} sizes="" width={isMobile ? 500 : 1000} height={1000} objectFit=""/>
          </div>
        </div>
      </div>
      <div className="justify-content-center container ">
        <div className=" ">
          <div className="col-lg-9 pt-4 px-2">
            <h1 className="pb-1 lh17 display-6">{contents?.title}</h1>
            <div className={`text-nowrap pb-4 
               "d-flex justify-content-start"
              `}>
              <StyledDate className="fs-lg" date={dayjs(published_at).format("DD MMMM YYYY")}/>
            </div>

            <StyledBlog dark={isDark} className="blog-fsz pt-4 border-top" dangerouslySetInnerHTML={{ __html: data?.contents?.body }}/>
          </div>
        </div>
        <div className="border-top "/>
        <ControlBarWrapper className={`py-3 d-flex  flex-fill`}>
          <m.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className={`d-flex flex-wrap align-items-center flex-2 ${matches && "w-100"}`}>
            <BlogShareBtn title={`${t("blog")} ${id}`} shareURL={`https://molhamteam.com/blog/${id}`}/>
            <MolhamButton id="blog-like-btn" CustomIconButton={<FiHeart className="like-btn fs-lg" size={18} fill={likeBtnClicked ? "#f74f78" : "rgba(247, 79, 120, 0.08)"}/>} label={like > 0 && like.toString()} variant={null} className={`text-capitalize btn-translucent-danger fs-lg px-3`} onClick={onLikeBtnClick}/>
            <MolhamButton id="blog-comment-btn" startIcon="fe-message-circle" label={reactingCounts.comments_count > 0 &&
            reactingCounts.comments_count.toString()} variant={null} className={`text-capitalize bg-faded-info fs-lg  ml-2 mr-md-2 mr-0 px-3`} onClick={onCommentBtnClick}/>
            <MolhamButton id="blog-more-btn" startIcon="fe-more-horizontal fs-xxl" className="px-2" variant={null} onClick={handleShowModal}/>
          </m.div>
        </ControlBarWrapper>

        <CommentContainer singleBlogURL={singleBlogURL} handleCloseAddEditCommentModal={handleCloseAddEditCommentModal} showAddEditCommentModal={showAddEditCommentModal} commentCount={counters?.comments} setReactingCounts={setReactingCounts} handleShowAddEditCommentModal={handleShowAddEditCommentModal}/>
      </div>
    </>);
};
export default Post;
const getServerSideProps: GetServerSideProps<Props> = async (ctx) => {
    const token = ctx.req.cookies.token;
    ctx.res.setHeader("Cache-Control", "public, s-maxage=360, stale-while-revalidate=59");
    const id = ctx.query.id;
    const locale = ctx.locale;
    let ip = ctx.req.headers["cf-connecting-ip"] ||
        ctx.req.headers["x-forwarded-for"] ||
        ctx.req?.connection?.remoteAddress;
    let headers = {
        "x-forwarded-for": ip,
        locale,
        "cf-ipcountry": ctx.req.headers?.["cf-ipcountry"],
        "x-forwarded-cf-ipcountry": ctx.req.headers?.["cf-ipcountry"]
    };
    headers = removeUndefined(headers);
    let blog: TBlog = null;
    try {
        const res = await getData<TBlog>(`${API_URL}/${blogsURL}/${id}`, token || null, headers);
        if (res.status !== 200) {
            throw new Error("Failed to fetch");
        }
        blog = res?.data;
    }
    catch (err) {
        return {
            notFound: true,
            redirect: {
                destination: "/blog",
                permanent: false
            }
        };
    }
    return {
        props: {
            blog
        }
    };
};
const ControlBarWrapper = styled.div `
  .dropdown-toggle:not(.dropdown-toggle-split)::after {
    display: none;
  }
  .donation-btn {
    padding-left: 30px;
    padding-right: 30px;
  }
  @media (max-width: 991.98px) {
    .donation-btn {
      display: block;
      width: 100%;
    }
  }
  .input-group > .form-control {
    flex: 2;
  }

  .btn-translucent-danger:hover,
  .btn-translucent-danger.active {
    background-color: rgba(247, 79, 120, 0.08);
    color: #f74f78 !important;
  }
`;
const StyledBlog = styled.div<{
    dark: boolean;
}> `
  p,
  span,
  div,
  li,
  ul,
  ol,
  blockquote,
  pre,
  code,
  table,
  th,
  td,
  form,
  fieldset,
  legend,
  input,
  textarea,
  button,
  select,
  option,
  hr,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  strong,
  a {
    color: ${(props) => (props.dark ? "unset" : "undefined")} !important;
    font-size: 18px !important;
    line-height: 1.7 !important;
    list-style: none;
  }
  a {
    color: var(--primary2) !important;
  }

  li::before {
    content: " ";
    background: var(--gray);
    border-radius: 50px;
    padding-inline: 4px;
    font-size: 6px;
    margin-inline-end: 0.5rem;
  }
`;
function addEllipsis(text, num) {
    if (!text)
        return "";
    if (text.length <= num) {
        return text;
    }
    else {
        return text.substring(0, num) + "...";
    }
}

    async function __Next_Translate__getServerSideProps__1a13f66bee5__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a13f66bee5__ as getServerSideProps }
  